var $ = jQuery;

/* eslint-disable */
import Clipboard from '../libs/clipboard.js';
/* eslint-enable */

function init() {
  new Clipboard('.heritage-icon-copy_link', {
    text: function(trigger) {
      event.preventDefault();
      var checkMark = $('.heritage-icon-check_sign_up.article__social-icon', trigger);
      var copyText = $('.copy-icon__copied', trigger);
      var tl = new TimelineLite();
      tl.to(checkMark, 0.5, {scale:1, opacity:1});
      tl.to(copyText, 0.5, {opacity:1});
      tl.to([checkMark, copyText], 0.5, {opacity: 0}, '+=1');
      tl.to(checkMark, 0.5, {scale:0});
      var value = window.location.href;

      if ($(trigger).prop('href') !== '#') {
        value = $(trigger).prop('href');
      }

      return value;
    }
  });
}



export { init as init };
